module.exports = __webpack_public_path__ + "images/emoji/pager.8d69e29982900c8ec97b.png";